import InputField from './InputField';
import TextField from './TextField';

// Model # and model description of an order. Pre-filled (from the template on create, from the
// order on edit) and editable. Both are saved on the order.
function OrderModelDetails({ mods_data, setMods_data, validateFields, loadingData, setDisableReset }) {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setMods_data((prev) => ({ ...prev, [name]: value }));
        setDisableReset(false);
    };

    return (
        <div id='OrderModelDetails' className='bg-white shadow-md rounded-lg mb-5 w-full overflow-hidden pt-6 px-2 md:pl-6 md:pr-4 pb-3'>
            <p className='font-medium text-lg mb-3'>Model Details</p>
            <div className='md:flex w-full'>
                <div className='w-full md:w-1/3 px-1 md:px-2'>
                    <InputField
                        disabled={loadingData}
                        placeholder='Enter Model #'
                        labelText={<>Model # <span className='text-red-600'>*</span></>}
                        name='model_number'
                        value={mods_data?.model_number || ''}
                        onChange={handleChange}
                        errorMessage={validateFields?.model_number}
                    />
                </div>
                <div className='w-full md:w-2/3 px-1 md:px-2'>
                    <TextField
                        disabled={loadingData}
                        placeholder='Enter Model Description'
                        labelText={<>Model Description <span className='text-red-600'>*</span></>}
                        name='model_description'
                        rows='2'
                        value={mods_data?.model_description || ''}
                        onChange={handleChange}
                        errorMessage={validateFields?.model_description}
                    />
                </div>
            </div>
        </div>
    );
}

export default OrderModelDetails;
